import { Caption, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

interface CustomerLegendProps {}

export const CustomerLegend: React.FC<CustomerLegendProps> = () => {
  return (
    <HStack alignItems={'center'} space={Spacing['inline.xxs']}>
      <Caption
        testId="qualified-client-legend"
        icon="QualifiedClient"
        iconSize="xs"
        text="Investidor qualificado"
        iconColor={Color['brand.secondary.principal']}
      />
      <Caption
        testId="professional-investor-legend"
        icon="ProfessionalInvestor"
        text="Investidor profissional"
        iconSize="xs"
        iconColor={Color['brand.tertiary.principal']}
      />
    </HStack>
  );
};
